import { Component, inject, DestroyRef, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './core/components/header/header.component';
import { ToastModule } from 'primeng/toast';
import { UploadingToastComponent } from './core/components/uploading-toast/uploading-toast.component';
import { MsalBroadcastService } from '@azure/msal-angular';
import { filter } from 'rxjs';
import { EventType, InteractionStatus } from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { AuthService } from './core/services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AppGlobalLoaderComponent } from './features/global-loader/global-loader.component';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    ToastModule,
    UploadingToastComponent,
    ProgressSpinnerModule,
    AppGlobalLoaderComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  isIframe = false;
  loginDisplay = signal(false);

  public authService = inject(AuthService);
  private readonly _msalBroadcastService = inject(MsalBroadcastService);
  private readonly _destroyRef = inject(DestroyRef);

  constructor() {
    this.authService.handleRedirect();

    this._msalBroadcastService.msalSubject$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        filter(
          (msg) =>
            msg.eventType === EventType.ACCOUNT_ADDED ||
            msg.eventType === EventType.ACCOUNT_REMOVED
        )
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });

    this._msalBroadcastService.inProgress$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        filter((status) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.authService.setActiveAccount();
        this.authService.getUserProfile();
      });
  }

  setLoginDisplay(): void {
    const isLoggedIn = this.authService.isLoggedIn();
    this.loginDisplay.set(isLoggedIn);
  }

  checkAndRenewToken(): void {
    const scopes = [environment.msalConfig.apiScope];
    this.authService.checkAndRenewToken(scopes);
  }

  loginRedirect(): void {
    this.authService.loginRedirect();
  }

  logout(): void {
    this.authService.logout();
  }
}
